import { CSSProperties } from "react";
import styled from "styled-components";
import { Description, Divider, Flex, Icon } from "@evergis/ui";

import { MapControlContainer } from "../../../MapControls/styled";

export const GeometrySelectionWrapper = styled(Flex)`
  align-items: center;
`;

export const CollapsableContainer = styled.div<{ collapsed?: boolean; $width?: string }>`
  z-index: 1;
  display: flex;
  padding: 0.25rem;
  box-sizing: border-box;
  color: white;
  position: relative;
  height: 2.5rem;
  align-items: center;
  width: ${({ collapsed, $width = "4rem" }) => (collapsed ? $width : "auto")};
  overflow: hidden;

  ${Divider} {
    height: 1.25rem;
    align-self: center;
    border-color: ${({ theme: { palette } }) => palette.element};
    margin: 0 0.25rem;
  }
`;

export const HideableArea = styled.div<{ isHidden?: boolean }>`
  display: flex;
  width: ${({ isHidden }) => (isHidden ? 0 : "auto")};
  overflow: hidden;
`;

export const ExpanderContainer = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;

  ${Divider} {
    align-self: center;
    height: 100%;
    border-color: ${({ theme: { palette } }) => palette.element};
  }

  button {
    width: auto;
  }
`;

export const GeometryResetControl = styled(Flex)`
  height: 1.25rem;
  border-left: 1px ${({ theme: { palette } }) => palette.element} solid;
  margin-left: 0.5rem;
  padding: 0 0.25rem;

  button {
    margin-top: -0.3rem;
  }
`;

export const DropdownIcon = styled(Icon)`
  cursor: pointer;
`;

export const SelectionControlContainer = styled(MapControlContainer)<{ active?: boolean }>`
  margin-right: 0;
  background-color: transparent;
  backdrop-filter: none;
  box-shadow: none;

  ${DropdownIcon} {
    transform: ${({ active }) => (active ? "rotate(-180deg)" : "rotate(0)")};
  }
`;

export const SelectionMenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectionMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  position: inherit;
  padding: 0.5rem 0.25rem;
  box-sizing: border-box;
  top: 1.5rem;
  left: -3.25rem;
  color: white;
  background: ${({ theme: { palette } }) => palette.panelBackground};
  backdrop-filter: blur(10px);
`;

export const BufferRadiusInputContainer = styled.div`
  display: inline-flex;

  input {
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const SwitchLabel = styled.div<{ active?: boolean }>`
  display: inline-block;
  color: ${({ theme: { palette } }) => palette.textPrimary};
  opacity: ${({ active }) => (active ? 1 : 0.54)};
  cursor: pointer;
`;

export const SwitchWrapper = styled.div`
  display: inline-block;
  margin: 0 1rem;
`;

export const SettingsDoubleSwitch = styled.div`
  display: flex;
  align-items: center;
`;

export const SettingsLink = styled.div`
  color: ${({ theme: { palette } }) => palette.primary};
  cursor: pointer;
`;

export const PopupContainer = styled.div<{ width?: CSSProperties["width"] }>`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  position: inherit;
  padding: 1rem;
  box-sizing: border-box;
  top: 2rem;
  left: -2.25rem;
  width: ${({ width }) => width};
  background: ${({ theme: { palette } }) => palette.panelBackground};
  backdrop-filter: blur(10px);
  color: ${({ theme: { palette } }) => palette.textPrimary};

  ${Description} {
    margin-top: 1.5rem;

    &:first-child {
      margin-top: 0;
    }
  }
`;
